import React from 'react';
import BlocksPanelStyled from './BlocksPanel.styled';
import PanelWrapper from '@/components/panelWrapper/PanelWrapper';
import BlockListing from '@/components/blockListing/BlockListing';
import ListingHeader from '@/components/listingHeader/ListingHeader';

interface BlocksPanelProps {
  title: string;
  subtitle: string;
  blocks: any[];
  onClose: any;
  setPanel: any;
  loading?: boolean;
  error?: boolean;
}

const BlocksPanel = ({
  title,
  subtitle,
  blocks,
  onClose,
  setPanel,
  loading,
  error,
}: BlocksPanelProps) => {
  return (
    <PanelWrapper>
      <BlocksPanelStyled className="blocks-panel">
        <PanelWrapper.Header title={title} onClose={onClose} />
        <ListingHeader title={subtitle} />
        <BlockListing
          setPanel={setPanel}
          blocks={blocks}
          error={error}
          loading={loading}
        />
        <PanelWrapper.Footer />
      </BlocksPanelStyled>
    </PanelWrapper>
  );
};

export default BlocksPanel;
